"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDecimal = void 0;
var formatDecimal = function (value, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 2; }
    if (!value) {
        return '0';
    }
    var threshold = 1 / Math.pow(10, (fractionDigits + 1));
    if (Math.abs(value) < threshold) {
        return ">0,".concat('0'.repeat(fractionDigits));
    }
    return value.toLocaleString('cs-CZ', {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
    });
};
exports.formatDecimal = formatDecimal;
//# sourceMappingURL=format-decimal.js.map